import { deleteOrder, getOrders, getOrder, storeOrder, exportOrder } from '@/api/orders';
import { ref } from 'vue';

import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import each from 'lodash/each';

export default function useOrders() {
  const orders = ref([]);
  const currentOrder = ref([]);
  const actionMessage = ref({});

  const fetchOrders = async () => {
    const fetchedOrders = await getOrders();
    orders.value = groupRelationship(fetchedOrders);
  };

  const fetchOrder = async (id) => {
    currentOrder.value = await getOrder(id);
  };

  const saveOrder = async (attributes) => {
    return storeOrder(attributes);
  };

  const prepareExportOrder = async (orderId) => {
    return exportOrder(orderId);
  };

  const cancelOrder = async (id) => {
    const deletedOrder = await deleteOrder(id);

    if (deletedOrder.type === 'success') {
      actionMessage.value.class = 'bg-success text-white';
    } else {
      actionMessage.value.class = 'bg-danger text-white';
    }
    actionMessage.value.text = deletedOrder.text;

    const fetchedOrders = await getOrders();
    orders.value = groupRelationship(fetchedOrders);
  };

  const groupRelationship = ({ data, included }) => {
    const relationships = groupBy(included, 'type');
    data.forEach((entry) => {
      const types = map(entry.relationships, (j) => j.data.type);
      entry.relationships = types.reduce((acc, relation) => {
        const currentRelation = relationships[relation].find((j) => {
          let currentId = null;
          each(entry.relationships, (x) => {
            if (x.data.type === relation) {
              currentId = x.data.id;
            }
          });
          return j.id === currentId;
        });
        acc[relation] = currentRelation;
        return acc;
      }, {});
    });
    return data;
  };

  return {
    actionMessage,
    cancelOrder,
    currentOrder,
    fetchOrder,
    fetchOrders,
    orders,
    saveOrder,
    prepareExportOrder,
  };
}
